import {BaseWrapper} from '../../framework/parameters/BaseWrapper';
import {BasicCriteria} from '../../framework/parameters/BasicCriteria';
import {Country} from '../message/Country';
import {CountryScenario} from './CountryScenario';

export class CountryWrapper extends BaseWrapper<Country, BasicCriteria, CountryScenario>  {}

